import React from 'react';
import {CheckFat} from "@phosphor-icons/react";

const IconCheckBig = (props) => (
    <CheckFat {...props}/>
);

export default IconCheckBig;
